import React from 'react';
import { Button } from 'reactstrap';

const SaveIconButton = ({ ...props }) => (
  <Button color="primary" outline {...props}>
    <i className="fa fa-check text-success" />
  </Button>
);

SaveIconButton.propTypes = {
  ...Button.propTypes,
};

export { SaveIconButton };
